import { useState } from "react";
import { Info } from "lucide-react";

/** Consumer-friendly (i) tooltip used on profession pickers, provider cards and filters. */
export const InfoTip = ({ headline, summary, testId }) => {
  const [open, setOpen] = useState(false);
  if (!headline && !summary) return null;
  return (
    <span className="relative inline-flex">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        aria-label="What does this mean?"
        className="inline-flex h-5 w-5 items-center justify-center rounded-full text-emerald-700 transition-colors hover:bg-emerald-50"
        data-testid={testId}
      >
        <Info className="h-3.5 w-3.5" />
      </button>
      {open && (
        <span
          className="absolute left-1/2 top-6 z-30 w-64 -translate-x-1/2 rounded-xl border border-slate-200 bg-white p-3 text-left shadow-xl"
          data-testid={`${testId}-content`}
        >
          <span className="block text-xs font-bold text-emerald-900">{headline}</span>
          <span className="mt-1 block text-xs leading-relaxed text-slate-600">{summary}</span>
        </span>
      )}
    </span>
  );
};
